import React from 'react'

import { useAssets } from '../_load/AssetsLoader'
import AssetListItem from './AssetListItem'

const AssetsList = () => {
  const assets = useAssets()

  return assets.map(item => <AssetListItem key={item.id} item={item} />)
}

export default AssetsList
